export default class LoadingService {
  constructor(blockUI, $timeout) {
    "ngInject";

    this.blockUI = blockUI;
    this.$timeout = $timeout;
  }

  showLoading(instanceId, msg) {
    const blockInstance = this.blockUI.instances.get(instanceId);

    blockInstance.start(msg);
  }

  hideLoading(instanceId, delay = 400) {
    const blockInstance = this.blockUI.instances.get(instanceId);

    if (delay === 0) {
      blockInstance.stop();
    } else {
      this.$timeout(() => {
        blockInstance.stop();
      }, delay)
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/common/services/loadingService.js